import type { AnalyticsSink } from "./analyticsPorts.js";

/**
 * Transparent decorator that adds an environment parameter to every event.
 * The environment string is app-defined, for example "dev" or "live".
 */
export class EnvTaggingSink implements AnalyticsSink {
  constructor(
    private readonly inner: AnalyticsSink,
    private readonly environment: string,
  ) {}

  log(event: string, params?: Record<string, string | number>): void {
    this.inner.log(event, { ...params, environment: this.environment });
  }
}
